import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { getSetupIpaBasicConfig, SETUP_IPA_BASIC_CONFIG_QUERY_KEY } from '../../../Administrador/Produtos/Components/SetupIpaBasicConfig/service';
import { normalizePriceMode, PRICE_MODE_CONFIG, PriceMode } from '../priceMode';

async function fetchPriceMode(fetchConfig: () => ReturnType<typeof getSetupIpaBasicConfig>): Promise<PriceMode> {
  try {
    const config = await fetchConfig();
    return normalizePriceMode(config?.adjustemend_price_mode);
  } catch {
    // Sem o basic-config, cai no modo padrão de cliente existente; as duas rotas continuam válidas.
    return normalizePriceMode(undefined);
  }
}

// Ponto de entrada único do menu: consulta o modo do cliente antes de navegar (RN04/RN05).
export function usePsychologicalPriceNavigation(): () => Promise<void> {
  const history = useHistory();
  const queryClient = useQueryClient();

  return useCallback(async () => {
    const mode = await fetchPriceMode(() =>
      queryClient.fetchQuery({ queryKey: SETUP_IPA_BASIC_CONFIG_QUERY_KEY, queryFn: getSetupIpaBasicConfig }),
    );
    history.push(PRICE_MODE_CONFIG[mode].route);
  }, [history, queryClient]);
}
